<template>
  <crud-form
    v-model="payload"
    :page-title="'Adicionar seção agrupamento'"
    :request-class="requestClass"
    :override-create-payload="overwriteBeforeCreate"
    :navigate-back-route="'group.edit'"
    :navigate-page-after-save="'group.edit'"
    :navigate-back-params="{ id: getGroupId }"
    :total-group="1"
  >
    <template slot="group-1">
      <form-group title="Informações de seção">
        <v-row>
          <v-col cols="6">
            <input-select
              id="input:produtoSecao"
              v-model="payload.produtoSecao"
              :rules="[requiredRule]"
              :items="produtoSecaoOptions"
              label="Nome seção"
              required
            />
          </v-col>
        </v-row>
      </form-group>
    </template>
  </crud-form>
</template>

<script>
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import NotificationMixin from '@/app/arch/mixins/NotificationMixin';
import CrudForm from '@/app/arch/components/crud/CrudForm.vue';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import GroupSectionRequest from 'Modules/contacard/produto/groups/group-section/GroupSectionRequest';
import ProdutoSecaoRequest from 'Modules/contacard/produto/secao/ProdutoSecaoRequest';

export default {
  name: 'GroupSectionForm',
  components: { CrudForm, FormGroup },
  mixins: [RulesMixin, NotificationMixin],
  data: () => ({
    requestClass: GroupSectionRequest,
    sectionRequest: ProdutoSecaoRequest,
    payload: {
      produtoAgrupamento: '',
      produtoSecao: '',
    },
    produtoSecaoOptions: [],
  }),
  computed: {
    getGroupId() {
      return this.$route.params.groupId;
    },
  },
  beforeMount() {
    if (this.getGroupId) {
      this.getSection();
    }
  },
  methods: {
    overwriteBeforeCreate() {
      return {
        produtoAgrupamento: this.getGroupId,
        produtoSecao: this.payload.produtoSecao,
      };
    },
    getSection() {
      this.sectionRequest.list({
        page: 1,
        PerPage: 1000,
      })
        .then(({ data }) => {
          this.setSectionOptions(data.data);
        }).catch(({ response }) => {
          this.showMessageError(response.data.message);
        });
    },
    setSectionOptions(sections) {
      this.requestClass.list(this.getGroupId, {
        page: 1,
        PerPage: 1000,
      }).then(({ data }) => {
        const items = [];
        sections.forEach(({ nomSecao, id }) => {
          if (!data.data.find((item) => item.nomSecao === nomSecao)) {
            items.push({
              value: id,
              text: nomSecao,
            });
          }
        });
        this.produtoSecaoOptions = items;
      }).catch(({ response }) => {
        this.showMessageError(response.data.message);
      });
    },
    showMessageError(message) {
      this.showErrorToast({
        text: message || 'Falha ao buscar seções!',
      });
    },
  },
};
</script>
